export default __webpack_public_path__ + "static/media/boule-logo.f633736d.png";